import React, { Dispatch, SetStateAction } from 'react';

import { PayPeriod, PayPeriods } from '@atom/types/payPeriod';
import { TimeEntryApproverInfo } from '@atom/types/user';
import {
  UserFilters,
  UserGroupTable,
  UserGroupTreeType,
} from '@atom/types/userGroups';

export enum Section {
  DIRECTORY = 'DIRECTORY',
  PEOPLE = 'PEOPLE',
  TIME_SHEET = 'TIME_SHEET',
}

export enum View {
  DIRECTORY = 'DIRECTORY',
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  DEACTIVATED = 'DEACTIVATED',
  TIME_SHEET = 'TIME_SHEET',
  TIME_SHEET_LIST = 'TIME_SHEET_LIST',
  ROLES = 'ROLES',
}

export const baseUserGroup = {
  id: 'root',
  name: 'directory',
  colorId: 0,
  userGroups: [],
};

export const initialPayPeriodYear = Number(new Date().getUTCFullYear());

interface Context {
  csvDownloadEndpoint: string;
  isMapView: boolean;
  setIsMapView: Dispatch<SetStateAction<boolean>>;
  open: Set<string>;
  toggleOpen: (id: string) => void;
  userGroupTree: UserGroupTreeType;
  treeLoading: boolean;
  refetchTree: () => Promise<any>;
  totalCount: number;
  table: UserGroupTable[];
  tableLoading: boolean;
  refetchTable: () => Promise<any>;
  setFilters: Dispatch<SetStateAction<UserFilters>>;
  handleGroup: (
    userGroupTree: UserGroupTreeType,
    path: UserGroupTreeType[],
    skipInitPagination?: boolean,
    replace?: boolean,
  ) => void;
  payPeriodsLoading: boolean;
  payPeriods: PayPeriods;
  userLoading: boolean;
  timeEntryApproverInfo: TimeEntryApproverInfo[];
  currentUserHasUserGroups: boolean;
  toggleExpanded: (section: Section) => void;
  activeTimeSheetGroup: any;
  setActiveTimeSheetGroup: Dispatch<SetStateAction<any>>;
  selectedPayPeriod: PayPeriod;
  activeGroup: UserGroupTreeType;
  activePath: UserGroupTreeType[];
}

export const initialState: Context = {
  csvDownloadEndpoint: '',
  isMapView: false,
  setIsMapView: () => {},
  open: new Set(),
  toggleOpen: () => {},
  // @ts-ignore
  userGroupTree: {},
  treeLoading: false,
  refetchTree: () => Promise.resolve({}),
  totalCount: 0,
  table: [],
  tableLoading: false,
  refetchTable: () => Promise.resolve({}),
  setFilters: () => {},
  handleGroup: () => {},
  userLoading: false,
  timeEntryApproverInfo: [],
  currentUserHasUserGroups: false,
  toggleExpanded: () => {},
  activeTimeSheetGroup: null,
  setActiveTimeSheetGroup: () => {},
  selectedPayPeriod: null,
  activeGroup: null,
  activePath: null,
};

const TeamContext = React.createContext<Context>(initialState);

export default TeamContext;
